import { BaseContainerModel } from "../base-container.model";
import { bl_pgw_payment_channel_hdr_RowClass, bl_pgw_payment_channel_hdr_RowInterface } from "../../dbschema";

export class PaymentChannelHeadersContainerModel extends BaseContainerModel {
    bl_pgw_payment_channel_hdr: bl_pgw_payment_channel_hdr_RowInterface = new bl_pgw_payment_channel_hdr_RowClass();
}
